import { EMPTY_FORM_TOKEN_CHAIN } from '../constants';

// Clears the persisted working state so a hard reload re-bootstraps it fresh, while keeping
// login/session and the auto-logout timers (loggedInAt/lastActivityTime). localStorage &
// sessionStorage share the same key.
export const wipePersistedPreferences = (storageKey: string): void => {
  const raw = window.localStorage.getItem(storageKey);
  if (raw) {
    const persisted = JSON.parse(raw);
    const login = persisted.userLogin || '';
    window.localStorage.setItem(
      storageKey,
      JSON.stringify({
        ...persisted,
        dashboards: [],
        reports: [],
        menuItems: [],
        menuId: null,
        defaultCurrencyFormat: null,
        defaultNumberFormat: null,
        filterValues: { [login]: {} },
        globalFilterValues: { [login]: [] },
        formTokens: EMPTY_FORM_TOKEN_CHAIN,
        autologoutPending: false,
      })
    );
  }
  window.sessionStorage.removeItem(storageKey);
};
